export default __webpack_public_path__ + "static/media/kitchen5-beforeB-1440w.a1baf2a5.avif";